
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Translations extends Vue {}
